<template>
  <div>
    <a-checkbox :checked="field.value" @change="onChange">{{
      config.text
    }}</a-checkbox>
  </div>
</template>
<script>
import { props } from './helper'
import { defineComponent } from 'vue'

export default defineComponent({
  props,
  setup (props) {
    const onChange = e => {
      props.handleChange(e.target.checked)
    }
    return { onChange }
  }
})
</script>
<style lang="less" scoped></style>
